module.exports = __webpack_public_path__ + "static/man-f-f3bdc0c8003c66725ac40f2c5df970fa.jpg";